// src/components/Privacy.js
import React, { useEffect } from 'react';
import Header from '../components/Header';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FooterMain from './FooterMain';

const Privacy = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  
  const currentLang = lang || (navigator.language?.split('-')[0] === 'it' ? 'it' : 'en');
  
  const getLocalizedPath = (path) => {
    return `/${currentLang}${path}`;
  };
  
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div className="App min-h-screen bg-white text-black transition-colors duration-300">
      <Header />
      <div className="flex justify-center p-8">
        <div className="w-full max-w-6xl bg-white text-gray-900 p-8 rounded-lg shadow-lg">
          <h1 className="text-5xl font-bold mb-4 text-center">{t('privacy.title')}</h1>
          <p className="text-justify">{t('privacy.intro')}</p>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.controller.title')}</h2>
          <p className="text-justify">{t('privacy.controller.description')}<Link to={getLocalizedPath("/contact")} className="text-green-600 hover:text-green-800 underline">
              {t('privacy.controller.contactLink')}
            </Link></p>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.purposes.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li>{t('privacy.purposes.item1')}</li>
            <li>{t('privacy.purposes.item2')}</li>
            <li>{t('privacy.purposes.item3')}</li>
            <li>{t('privacy.purposes.item4')}</li>
            <li>{t('privacy.purposes.item5')}</li>
            <li>{t('privacy.purposes.item6')}</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.dataTypes.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li>{t('privacy.dataTypes.item1')}</li>
            <li>{t('privacy.dataTypes.item2')}</li>
            <li>{t('privacy.dataTypes.item3')}</li>
            <li>{t('privacy.dataTypes.item4')}</li>
            <li>{t('privacy.dataTypes.item5')}</li>
            <li>{t('privacy.dataTypes.item6')}</li>
          </ul>
          <p className="text-justify">{t('privacy.dataTypes.cookieInfo')}</p>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.legalBasis.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li>{t('privacy.legalBasis.item1')}</li>
            <li>{t('privacy.legalBasis.item2')}</li>
            <li>{t('privacy.legalBasis.item3')}</li>
            <li>{t('privacy.legalBasis.item4')}</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.recipients.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li>{t('privacy.recipients.item1')}</li>
            <li>{t('privacy.recipients.item2')}</li>
            <li>{t('privacy.recipients.item3')}</li>
            <li>{t('privacy.recipients.item4')}</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.international.title')}</h2>
          <p className="text-justify">{t('privacy.international.description')}</p>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.retention.title')}</h2>
          <p className="text-justify">{t('privacy.retention.description')}</p>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.rights.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li>{t('privacy.rights.item1')}</li>
            <li>{t('privacy.rights.item2')}</li>
            <li>{t('privacy.rights.item3')}</li>
            <li>{t('privacy.rights.item4')}</li>
            <li>{t('privacy.rights.item5')}</li>
            <li>{t('privacy.rights.item6')}</li>
            <li>{t('privacy.rights.item7')}</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.security.title')}</h2>
          <p className="text-justify">{t('privacy.security.description')}</p>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.cookiePolicy.title')}</h2>
          <p className="text-justify">{t('privacy.cookiePolicy.description')}</p>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.updates.title')}</h2>
          <p className="text-justify">{t('privacy.updates.description')}</p>

          <h2 className="text-2xl font-semibold mt-6">{t('privacy.contact.title')}</h2>
          <p className="text-justify">
            {t('privacy.contact.description')}{' '}
            <Link to={getLocalizedPath("/contact")} className="text-green-600 hover:text-green-800 underline">
              {t('privacy.contact.contactLink')}
            </Link>{' '}
            {t('privacy.contact.navigationInfo')}
          </p>
        </div>
      </div>
      <FooterMain />
    </div>

  );
};

export default Privacy;
